import ReactDOM from 'react-dom/client';
import TagManager from 'react-gtm-module';
import { defaults } from 'react-sweet-state';
import { enableMapSet, setAutoFreeze } from 'immer';

import * as env from 'src/lib/env';
import * as logRocket from 'src/lib/logrocket';
import * as sentry from 'src/lib/sentry';

import { isLocalhost, isProduction, isStaging, isTeadsProduction, isTesting } from './lib/url';
import App from './App';

// Enable Map/Set support in "immer"
enableMapSet();
setAutoFreeze(false);

const host = window.location.href;
const isStagingHost = isStaging(host);
const isProductionHost = isProduction(host) || isTeadsProduction(host);
const isTestingHost = isTesting(host);
const acceptTunnelHosts = env.getAcceptTunnelHosts();
const acceptableHost =
  acceptTunnelHosts || isLocalhost(host) || isTestingHost || isStagingHost || isProductionHost;

if (acceptableHost) {
  if (!isTestingHost) {
    const gtmId = env.getGtmId();
    if (gtmId) {
      TagManager.initialize({ gtmId });
    }

    sentry.init();
  }

  if (isProductionHost) {
    logRocket.init();
  }

  const root = ReactDOM.createRoot(document.getElementById('app'));
  root.render(
    // TODO: StrictMode brakes the app(useEffect() multiple call, etc.), check if possible to enable
    // <React.StrictMode>
    <App />
    // </React.StrictMode>
  );
}

if (env.getAppEnv() === 'development') {
  defaults.devtools = true;
}
